module.exports = __webpack_public_path__ + "media/images/emoticons/loveletter-f309028bda12ed419dca09c5d55c4653.gif";